export const SELECTED_COLUMNS: string[] = [
  "s_no",
  "upload_id",
  "name",
  "added_date",
  "accept_date",
  "validate_time",
  "accept_time",
  "existing_count",
  "add_count",
  "update_count",
  "delete_count",
  "suppress_validations",
  "check",
  "user_name",
  "status",
  "conflict",
  "log",
  "action",
];
